/// <amd-module name="SuiteCommerce.ProductLeadTime.PDP.Configuration"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.ProductLeadTime.PDP.Configuration", ["require", "exports", "SuiteCommerce.ProductLeadTime.Common.Configuration"], function (require, exports, Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.PDPConfiguration = void 0;
    var PDPConfiguration = /** @class */ (function (_super) {
        __extends(PDPConfiguration, _super);
        function PDPConfiguration() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(PDPConfiguration, "message", {
            get: function () {
                return this.get('productleadtime.message');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(PDPConfiguration, "messageFormat", {
            get: function () {
                return this.get('productleadtime.messageFormat');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(PDPConfiguration, "dateFormat", {
            get: function () {
                return this.get('productleadtime.dateFormat');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(PDPConfiguration, "leadTimeThreshold", {
            get: function () {
                return parseInt(this.get('productleadtime.threshold'), 10);
            },
            enumerable: false,
            configurable: true
        });
        return PDPConfiguration;
    }(Configuration_1.Configuration));
    exports.PDPConfiguration = PDPConfiguration;
});
